import React, { useState } from 'react';
import "./styles.css"
import { CSSTransition } from 'react-transition-group';
import styled from "styled-components"

const ExpandTitle = styled.div`
  width: 100%;
  display: flex;
  flex-wrap:nowrap;
  align-items: center;
  justify-content: space-between;
  color:#000;
  h2{
    margin-bottom:0;
    font-weight:600;
    + .action{
      margin-left:5px;
    }
  }
  .action {
    font-size: 24px;
    line-height:34px;
    font-weight: 700;
    color:#000;
    cursor: pointer;
  }
`

const ExpandSection = styled.div`
  background-color: #fff;
	border: 1px solid #C9C9C9;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
	border-radius: 6px;
	margin-bottom:30px;
`
const ExpandHeader = styled.div`
  padding:5px 15px;
  @media(min-width:768px){
    padding:10px 20px;
  }
`
const ExpandContent = styled.div`
  padding:0 15px 20px 15px;
  @media(min-width:768px){
    padding:0 20px 30px 20px;
  }
`

const Expandable = ({ title, children, defaultExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <ExpandSection className='expand-section'>
      <ExpandHeader className="expand-header" onClick={toggleExpansion}>
        <ExpandTitle className='expand-title'>
          <h2 className='h6'>{title}</h2> 
          <button type='button' className='action'>{isExpanded ? '-' : '+'}</button>
        </ExpandTitle>
      </ExpandHeader>
      <CSSTransition
        in={isExpanded}
        timeout={300}
        unmountOnExit
      >
        <ExpandContent className="expand-content">{children}</ExpandContent>
      </CSSTransition>
    </ExpandSection>
  );
};

export default Expandable;